module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_vm._l((_vm.marketList), function(market) {
    return (market.name == _vm.marketsName) ? _c('v-card', {
      key: market.marketId,
      staticClass: "mb-3"
    }, [_c('v-img', {
      attrs: {
        "height": "200",
        "src": market.image
      }
    }, [_c('v-container', {
      attrs: {
        "fill-height": "",
        "fluid": "",
        "pa-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "fill-height": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "font-20 fw-700 white--text ml-3",
      domProps: {
        "textContent": _vm._s(_vm.marketsName)
      }
    })])], 1)], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', [_vm._l((_vm.postList), function(post, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media"
    }, _vm._l((_vm.userDetailList), function(user, index) {
      return (post.postingUserId == user.userId) ? _c('div', {
        key: index,
        staticClass: "ml-2 pt-3 mr-2"
      }, [_c('div', {
        staticClass: "mb-3"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "34"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image != null),
          expression: "user.image != null"
        }],
        attrs: {
          "src": user.image,
          "alt": user.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image == null),
          expression: "user.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                            " + _vm._s(user.userName
        .trim()
        .substring(0, 1)
        .toLocaleUpperCase()) + "\n                          ")])]), _vm._v(" "), _c('span', {
        staticClass: "pl-2 pointer hover-color font-16 fw-700",
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_vm._v("\n                          " + _vm._s(user.nickName) + "\n                          "), _c('span', [_vm._v("(" + _vm._s(user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
        staticClass: "px-2 fw-500 font-14"
      }, [_c('v-icon', {
        attrs: {
          "size": "16"
        }
      }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(post.postingTime)) + "\n                        ")], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_vm._l((_vm.userDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('div', {
          key: index,
          staticClass: "px-0"
        }, [(post.postingImg != '') ? _c('span', {
          staticClass: "rounded-circle mr-4 img-responsive posts-image pointer",
          domProps: {
            "innerHTML": _vm._s(post.postingImg)
          },
          on: {
            "click": function($event) {
              return _vm.findsel(post)
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [_c('h2', {
        staticClass: "fw-700 pointer break-word",
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v(_vm._s(post.postingTitle))]), _vm._v(" "), _c('h4', {
        staticClass: "mb-3 py-2",
        domProps: {
          "innerHTML": _vm._s(post.postingContent)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "mt-1 justify-space-between"
      }, [_c('div', {
        staticClass: "social"
      }, [_c('span', {
        staticClass: "pointer"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
        staticClass: "font-1x fw-400 ml-1"
      }, [_vm._v(_vm._s(post.bonus.toFixed(2)))])], 1), _vm._v(" "), (post.postingStatus == 0) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == 1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == -1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingCountComments))])], 1), _vm._v(" "), _vm._l((_vm.userDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('span', {
          staticClass: "ml-2"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.retweet')
          },
          on: {
            "click": function($event) {
              return _vm.modalzf(post, user)
            }
          }
        }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-400 ml-1"
        }, [_vm._v(_vm._s(post.postingCountForword))])], 1) : _vm._e()
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [(post.postingCollection == 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("\n                                  fa fa-star\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [(post.postingCollection != 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("fa fa-star")]) : _vm._e()], 1)], 2)])])], 2), _vm._v(" "), _c('div', {
        staticClass: "mt-3"
      }, _vm._l((_vm.commentList), function(postcomments, index) {
        return (post.postingId == postcomments.commentsPostingId) ? _c('span', {
          key: index,
          staticClass: "flex-middle"
        }, [_vm._l((_vm.commentUserDetailList), function(userpopular, index) {
          return (postcomments.commentsUserId == userpopular.userId) ? _c('span', {
            key: index
          }, [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(userpopular.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image != null),
              expression: "userpopular.image != null"
            }],
            attrs: {
              "src": userpopular.image,
              "alt": userpopular.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image == null),
              expression: "userpopular.image == null"
            }],
            staticClass: "headline white--text"
          }, [_vm._v("\n                                " + _vm._s(userpopular.userName
            .trim()
            .substring(0, 1)
            .toLocaleUpperCase()) + "\n                              ")])])], 1) : _vm._e()
        }), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-500 ml-2"
        }, [(post.postingContent.length > 20) ? _c('span', [_vm._v(_vm._s(postcomments.commentsContext))]) : _c('span', [_vm._v(_vm._s(postcomments.commentsContext) + "……")])])], 2) : _vm._e()
      }), 0)]) : _vm._e()
    }), 0)])])])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.timestamp
    },
    on: {
      "infinite": _vm.getPostList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30 fw-500"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "32"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage != null),
      expression: "postUserImage != null"
    }],
    attrs: {
      "src": _vm.postUserImage,
      "alt": _vm.postUserName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage == null),
      expression: "postUserImage == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                          " + _vm._s(_vm.postUserName
    .trim()
    .substring(0, 1)
    .toLocaleUpperCase()) + "\n                        ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18 fw-700",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_vm._v(_vm._s(_vm.postNickName))]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16 fw-700"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.at')) + "\n                          "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(_vm.postDate)) + "\n                        ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-14 fw-700"
  }, [_vm._v(_vm._s(_vm.postTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg4": ""
    }
  }, [_c('app-right')], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abf3966c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/MarketPosts.vue
// module id = 464
// module chunks = 0